import { Box, styled } from '@mui/material';
import noDataIcon from '../../../../../../assets/no-data-icon.svg';

export const SearchResultsWrapper = styled(Box)({
  color: 'black',
  cursor: 'default',
  padding: '20px 0 30px 0',
  display: 'flex',
  flexDirection: 'column'
});

export const SearchResultsItemWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  padding: '10px 20px'
});

export const ContactName = styled('div')({
  fontSize: '18px',
  fontWeight: '500',
  display: 'flex',
  marginRight: 'auto',
  '&:hover': { color: '#0675DD', cursor: 'pointer' }
});

export const ContactInfoList = styled('ul')(({ isPhone }: { isPhone?: boolean }) => ({
  fontSize: '12px',
  display: 'flex',
  flexDirection: 'row',
  margin: '3px 0 0 0',
  alignItems: 'center',
  listStyleType: 'none',
  padding: '0 10px 0 0',
  flexWrap: 'wrap',
  '& > li': {
    margin: '2px 10px 0 0',
    paddingRight: '10px',
    borderRight: 'solid 1px #ECECEC',
    '&:last-child': {
      borderRight: 'none',
      flexBasis: isPhone ? '100%' : 'inherit',
      paddingTop: isPhone ? '4px' : '0'
    }
  }
}));

export const ScrollWrapper = styled(Box)(({ isPhone }: { isPhone: boolean }) => ({
  maxHeight: isPhone ? '75vh' : '70vh',
  height: isPhone ? '75vh' : 'auto',
  display: 'flex',
  flexDirection: 'column',
  scrollbarWidth: 'thin',
  scrollbarColor: '#888 #f0f0f0',
  overflow: 'hidden'
}));

export const NoDataImage = styled(() => (
  <img src={noDataIcon} alt="No Data" style={{ width: '50px', margin: '10px 0' }} />
))(() => ({
  display: 'flex'
}));
